import React from 'react';

// 필수입력 *
const Asterisk = () => {
  return (
    <span
      style={{
        color: 'red',
        // fontSize: '20px',
        marginLeft: '.25rem',
        width: 0,
        height: '1rem',
        fontSize: '1rem',
        // paddingTop: '10px',
        // marginLeft: '3px',
      }}
    >
      *
    </span>
  );
};

export default Asterisk;
